export const buttonApiObj = {
    DOCUEMNT: 'partnerDocument',
    PARTNER: 'partner',
    COURIER: 'courier',
};
